import React from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "./ChartsDynamicColor";

const ApexRadial = ({ dataColors, percentPresent }) => {
  const apexRadialChartColors = getChartColorsArray(dataColors);
  const series = [percentPresent];
  const options = {
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,
        dataLabels: {
          name: {
            fontSize: "13px",
            color: void 0,
            offsetY: 45,
          },
          value: {
            offsetY: 10,
            fontSize: "13px",
            color: void 0,
            formatter: function (e) {
              return e + "%";
            },
          },
        },
      },
    },
    colors: apexRadialChartColors,
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        shadeIntensity: 0.15,
        inverseColors: !1,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 65, 91],
      },
    },
    stroke: {
      dashArray: 4,
    },
    labels: ["Present"],
  };
  return (
    <ReactApexChart
      options={options}
      series={series}
      type="radialBar"
      height="150"
      className="apex-charts"
    />
  );
};

export default ApexRadial;
